import { render, staticRenderFns } from "./TabelaPaginada.vue?vue&type=template&id=6deef818&scoped=true&"
import script from "./TabelaPaginada.vue?vue&type=script&lang=js&"
export * from "./TabelaPaginada.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPaginada.vue?vue&type=style&index=0&id=6deef818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deef818",
  null
  
)

export default component.exports